import moment from 'moment'
import { isObject } from 'lodash';

export const GetStartOfDay = ()=>{ 
    return new moment().startOf('day')._d;    
}

export const GetDurationInHours = (startDate, endDate)=>{
    var start = new moment(startDate)
    var end = new moment(endDate);
    return  moment.duration(end.diff(start)).asHours();    
}
export const GetDurationInDays = (startDate, endDate)=>{
    var start = new moment(startDate)
    var end = new moment(endDate);
    return  moment.duration(end.diff(start)).asDays();    
}

export const GetDate = (date)=>{
    return new moment(date)._d;
}
export const FormattedDate = (date)=>{
    return new moment(FormattedDateString(date)).startOf('day')._d;
}

export const GetDateISOString = (date)=>{
    var val = isObject(date)?date: date.split('T')[0]
    return new moment(val).format('YYYY-MM-DDT[00:00:00Z]')   
}

export const GetISODate = (date)=>{    
    return new moment(GetDateISOString(date), 'YYYY-MM-DDT[00:00:00Z]')._d
}

export const FormattedDateString = (date)=>{  
    let year = date.getFullYear();
    let month = (1 + date.getMonth()).toString().padStart(2, '0');
    let day = date.getDate().toString().padStart(2, '0');
  
    return year + '-' + month + '-' + day;
}

export const FormatDateFromString = (date)=>{
    const dateVal = GetDate(date);
    let year = dateVal.getFullYear();
    let month = (1 + dateVal.getMonth()).toString().padStart(2, '0');
    let day = dateVal.getDate().toString().padStart(2, '0');  
    return  month + '/' + day + '/' + year;
   
}

export const FormattedToday = GetDate(GetDateISOString(new Date()));

export const AddHours = (date, hours)=>{
    var dateVal = new moment(date);
    return (dateVal.add(hours, "hours"))._d;
}

export const AddDays = (date, days)=>{
    var dateVal = new moment(date);
    return (dateVal.add(days, "days"))._d;
}

export const IsTodayOrLater = (date)=>{
    var today = new moment().format('YYYY-MM-DDT[00:00:00Z]') 
    var dateVal = new moment(date).format('YYYY-MM-DDT[00:00:00Z]') ;    
    return today <= dateVal;  
}

export const IsTodayOrBefore = (date)=>{
    var today = new moment().format('YYYY-MM-DDT[00:00:00Z]') 
    var dateVal = new moment(date).format('YYYY-MM-DDT[00:00:00Z]') ;    
    return today >= dateVal;  
}
export const IsToday = (date)=>{
    var today = new moment().format('YYYY-MM-DDT[00:00:00Z]') 
    var dateVal = new moment(date).format('YYYY-MM-DDT[00:00:00Z]') ;    
    return today === dateVal;  
}

export const IsBefore = (date)=>{
    var today = new moment().format('YYYY-MM-DDT[00:00:00Z]') 
    var dateVal = new moment(date).format('YYYY-MM-DDT[00:00:00Z]') ;    
    return today > dateVal;  
}

export const IsLater = (date)=>{
    var today = new moment().format('YYYY-MM-DDT[00:00:00Z]') 
    var dateVal = new moment(date).format('YYYY-MM-DDT[00:00:00Z]') ;    
    return today < dateVal;  
}